'use client'

import { forwardRef, useImperativeHandle, useState } from "react";
import styles from './ua.module.scss'
import Icon from "@/components/icon/Icon";
import Button from "@/components/button/Button";
import Image from "next/image";
import Pill from "@/components/pills/Pill";

const Highlights = forwardRef((props, ref) => {
  
  const vehicle = props.vehicle
  const [details, setDetails] = useState()
  
  const onLoad = (data) => {
    if (data) setDetails(data)
  }

  const reportUrl = () => {
    return data?.report_url
  }

  useImperativeHandle(ref, () => ({
    reportUrl
  }))
  
  return <section className='white'>
    <div className="flex-row flex-with-gap flex-align-center text-align-center">
      { vehicle.condition != 1 && vehicle.history?.report_url &&
      <div className="flex-col flex-stretch">
        <Button {...props} href={vehicle.history?.report_url} target="_blank">
          <div className="flex-column flex-align-middle flex-align-center">
            <div className="flex-col">
              <Image src={ process.env.NEXT_PUBLIC_CDN + "/images/partner/carfax.png"} height="24" width="124" alt="Carfax Report"></Image>
            </div>
            <div className="flex-col" style={{width:'124px'}}>
              <Pill theme={['primary-faint','full']}>Free Report &gt;</Pill>
            </div>
          </div>
        </Button>
      </div>
      }
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="family-friendly"></Icon></div>
          <div className="flex-col text-sm">{ 'Great for Family' }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="great-for-work"></Icon></div>
          <div className="flex-col text-sm">{ 'Great For Work' }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="dollar"></Icon></div>
          <div className="flex-col text-sm">{ 'Under 10K' }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="viewed"></Icon></div>
          <div className="flex-col text-sm">{ 'Popular' }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="thumbs-up"></Icon></div>
          <div className="flex-col text-sm">{ 'Hot' }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="new"></Icon></div>
          <div className="flex-col text-sm">{ 'New' }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="deal"></Icon></div>
          <div className="flex-col text-sm">{ 'Great Deal' }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="speedometer"></Icon></div>
          <div className="flex-col text-sm">{ 'Low Miles' }</div>
        </div>
      </div>
      {/* <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="owner-3"></Icon></div>
          <div className="flex-col text-sm">{ details?.owners?.display_text }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="accident"></Icon></div>
          <div className="flex-col text-sm">{ details?.accident?.display_text }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="veh-type-sedan"></Icon></div>
          <div className="flex-col text-sm">{ details?.use_type?.display_text }</div>
        </div>
      </div>
      <div className="flex-col flex-stretch">
        <div className="flex-column flex-align-middle flex-align-center">
          <div className={ 'flex-col ' + styles.ft_ico }><Icon {...props} name="service"></Icon></div>
          <div className="flex-col text-sm">{ details?.service?.count } records</div>
        </div>
      </div> */}
    </div>
  </section>
})

Highlights.displayName = "VHR";
export default Highlights;